import {
    Box,
    Button, CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider, Grid,
    IconButton,
    Alert as MuiAlert,
    Snackbar,
    Typography,
    useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Alert } from 'antd';
import axios from 'axios';
import { isAfter } from 'date-fns';
import { t } from 'i18next';
import React, { useContext, useEffect, useState } from 'react';
import { configUrl } from '../config';
import { LoginContext } from '../contexts/LoginContext';
import assignTopicTestsToUser from '../services/OwnTestCreationServices/assignTopicTestsToUser';
import getAllSubscriptionsService from '../services/OwnTestCreationServices/getAllSubscriptionsService';
import getUserTopicsForTestsService from '../services/OwnTestCreationServices/getUserTopicsForTestsService';
import styles from '../styles/OwnTestCreation.module.css';
import CustomModal from './CustomModal/CustomModal';
import TestDetailsPage from './TestDetailsPage';

const data1 = [
    {
        "Id": 36,
        "ParentId": 0,
        "Guid": "5d75b9be-1758-4642-80ea-2f753881dd0b",
        "Level": 1,
        "Label": null,
        "TopicName": "Maths",
        "TotalTests": 0,
        "AssignedTests": 0,
        "SubObjectList": [
            {
                "Id": 37,
                "ParentId": 36,
                "Guid": "9c89bb5e-0172-4f78-b79c-2200e35c94ec",
                "Level": 2,
                "Label": null,
                "TopicName": "Algebra",
                "TotalTests": 0,
                "AssignedTests": 0,
                "SubObjectList": [
                    {
                        "Id": 123,
                        "ParentId": 37,
                        "Guid": "f70067d8-9f48-4c44-964f-088a635aad61",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Matrices and Determinants",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 43,
                        "ParentId": 37,
                        "Guid": "80b330cf-d409-4ac6-b0c2-21c6f0708bde",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Linear Inequalities",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 45,
                        "ParentId": 37,
                        "Guid": "b741579b-8570-448e-a450-3e166fdbf3de",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Mathematic Induction Application",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 134,
                        "ParentId": 37,
                        "Guid": "202d8253-2338-4fad-a7cb-4e1b6249cb19",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Complex Numbers and Quadratic equation",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 53,
                        "ParentId": 37,
                        "Guid": "5457a717-1c22-40e4-b9da-e8e42be711fc",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Sets Relations and Functions",
                        "TotalTests": 0,
                        "AssignedTests": 0,
                        "SubObjectList": [
                            {
                                "Id": 235,
                                "ParentId": 53,
                                "Guid": "f7592601-fcfd-48f0-9e87-d5cd9aecfb64",
                                "Level": 4,
                                "Label": null,
                                "TopicName": "Relations and Functions",
                                "TotalTests": 1,
                                "AssignedTests": 0,
                                "SubObjectList": [
                                    {
                                        "Id": 335,
                                        "ParentId": 235,
                                        "Guid": "f7592601-fcfd-48f0-9e87-d5cd9aecfb64",
                                        "Level": 4,
                                        "Label": null,
                                        "TopicName": "Relations and Functions1",
                                        "TotalTests": 1,
                                        "AssignedTests": 0,
                                        "SubObjectList": [
                                            {
                                                "Id": 435,
                                                "ParentId": 335,
                                                "Guid": "f7592601-fcfd-48f0-9e87-d5cd9aecfb64",
                                                "Level": 4,
                                                "Label": null,
                                                "TopicName": "Relations and Functions2",
                                                "TotalTests": 1,
                                                "AssignedTests": 0,
                                                "SubObjectList": [
                                                    {
                                                        "Id": 535,
                                                        "ParentId": 435,
                                                        "Guid": "f7592601-fcfd-48f0-9e87-d5cd9aecfb64",
                                                        "Level": 4,
                                                        "Label": null,
                                                        "TopicName": "Relations and Functions3",
                                                        "TotalTests": 1,
                                                        "AssignedTests": 0,
                                                        "SubObjectList": []
                                                    },
                                                ]
                                            },
                                        ]
                                    },
                                ]
                            },
                            {
                                "Id": 236,
                                "ParentId": 53,
                                "Guid": "3799a77a-3d98-4ba2-83b9-684152d61307",
                                "Level": 4,
                                "Label": null,
                                "TopicName": "Sets",
                                "TotalTests": 1,
                                "AssignedTests": 0,
                                "SubObjectList": []
                            }
                        ]
                    },
                    {
                        "Id": 135,
                        "ParentId": 37,
                        "Guid": "e7e452f9-c8f9-44ad-bd3b-81d78ca948bc",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Relations and Functions",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 136,
                        "ParentId": 37,
                        "Guid": "527414bc-3a17-4b23-b6d9-34fe4e7b9a5e",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Sets",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 41,
                        "ParentId": 37,
                        "Guid": "82bc89f8-bc50-46c7-9731-5cb4e54a7061",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Complex Numbers",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 51,
                        "ParentId": 37,
                        "Guid": "d2ad21f9-b90d-4e9a-80e4-411af2c71a50",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Quadratic Equations",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 42,
                        "ParentId": 37,
                        "Guid": "11d1f246-6fa8-4f84-89e3-c5d49f3a5d42",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Determinants",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 47,
                        "ParentId": 37,
                        "Guid": "daaa042c-11af-4eb0-9640-bbcacb85adad",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Matrices",
                        "TotalTests": 2,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 48,
                        "ParentId": 37,
                        "Guid": "acb936ed-19b5-424e-be68-54579128cd66",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Permutations and Combinations",
                        "TotalTests": 2,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 54,
                        "ParentId": 37,
                        "Guid": "2cc4f3ee-e078-4daf-99ae-69f981f60d02",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Statistics",
                        "TotalTests": 2,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 46,
                        "ParentId": 37,
                        "Guid": "2d79942a-53dd-4a4a-bdb5-75462a035613",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Mathematical Reasoning",
                        "TotalTests": 2,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 52,
                        "ParentId": 37,
                        "Guid": "73b09d26-c94f-4b6b-b0a8-0b0d79b962a0",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Sequences and Series",
                        "TotalTests": 4,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 49,
                        "ParentId": 37,
                        "Guid": "c06d692b-5067-4bb4-a3d4-f3ec549cc5fe",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Probability",
                        "TotalTests": 4,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 38,
                        "ParentId": 37,
                        "Guid": "9c52438c-d201-43b0-95a3-b362cdcfaa88",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "3-D Geometry",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 40,
                        "ParentId": 37,
                        "Guid": "ae53b6f3-84b3-4b02-ad15-2c11f2900f0e",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Binomial Theorem",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 55,
                        "ParentId": 37,
                        "Guid": "e0177b7d-b74f-410d-bb51-50046b1f0e8b",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Vectors",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    }
                ]
            },
            {
                "Id": 62,
                "ParentId": 36,
                "Guid": "0fb52e6a-b798-4009-b01f-5ecaa2828ec3",
                "Level": 2,
                "Label": null,
                "TopicName": "Calculus",
                "TotalTests": 0,
                "AssignedTests": 0,
                "SubObjectList": [
                    {
                        "Id": 137,
                        "ParentId": 62,
                        "Guid": "2cc03ffe-0754-4489-bf64-ae6eaae845c7",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Indefinite and definite Integrals",
                        "TotalTests": 1,
                        "AssignedTests": 1,
                        "SubObjectList": []
                    },
                    {
                        "Id": 70,
                        "ParentId": 62,
                        "Guid": "039d8435-4afa-4dfd-8a2f-615a9c0a6f0f",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Indefinite Integrals",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 71,
                        "ParentId": 62,
                        "Guid": "31e6df24-5127-461e-bed2-c1511dc918eb",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Limits",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 65,
                        "ParentId": 62,
                        "Guid": "fe1ad3ed-d3af-458e-8e92-a0eb99b679f4",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Continuity and Differentiability",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 63,
                        "ParentId": 62,
                        "Guid": "b365da32-df47-48b0-878a-33e3bf0eb8e8",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Appliction Of Derivatives",
                        "TotalTests": 4,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 68,
                        "ParentId": 62,
                        "Guid": "906cafc4-a653-4135-be4d-b59661d6ca66",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Diffrential Equations",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 69,
                        "ParentId": 62,
                        "Guid": "268b4fd0-e641-4f26-9b71-29d443d31a2f",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Functions",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 64,
                        "ParentId": 62,
                        "Guid": "bdc1ffdc-fe5b-4532-8b61-2664e0b897c2",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Area Under Curves",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 66,
                        "ParentId": 62,
                        "Guid": "47196520-016e-4545-b786-19799a8a5c9f",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Definite Integral",
                        "TotalTests": 2,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    }
                ]
            },
            {
                "Id": 72,
                "ParentId": 36,
                "Guid": "d52e97ff-045d-4058-9dbe-606177f84bb2",
                "Level": 2,
                "Label": null,
                "TopicName": "Coordinate Geometry",
                "TotalTests": 0,
                "AssignedTests": 0,
                "SubObjectList": [
                    {
                        "Id": 138,
                        "ParentId": 72,
                        "Guid": "c43c732b-56bb-4425-b6ff-8d94093d0690",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Conic Section",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 75,
                        "ParentId": 72,
                        "Guid": "c982ede9-d60d-452c-88f3-fbe320336de9",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Hyperbola",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 76,
                        "ParentId": 72,
                        "Guid": "5c496ca0-d52b-444d-8d4e-3e9c22ccec5f",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Parabola",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 73,
                        "ParentId": 72,
                        "Guid": "5394cfa9-0fd7-43d0-8b61-f06ee748439a",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Circle",
                        "TotalTests": 2,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 77,
                        "ParentId": 72,
                        "Guid": "e848a695-0217-44a0-bf82-b11bb89624ab",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Straight Lines",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    }
                ]
            },
            {
                "Id": 56,
                "ParentId": 36,
                "Guid": "6588c86d-0d96-485c-9563-8de0abdf15cf",
                "Level": 2,
                "Label": null,
                "TopicName": "Trigonometry",
                "TotalTests": 0,
                "AssignedTests": 0,
                "SubObjectList": [
                    {
                        "Id": 59,
                        "ParentId": 56,
                        "Guid": "771d31ba-d2a1-414c-9cae-798be818e36f",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Solutions Of Trianges",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 61,
                        "ParentId": 56,
                        "Guid": "c32e0964-fea4-4c0b-a4be-b63b4d8d6b37",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Trignometric Ratios and Identities",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 60,
                        "ParentId": 56,
                        "Guid": "fd694486-74f9-4a40-b06b-161a05a73180",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Trignometric Equations",
                        "TotalTests": 2,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    }
                ]
            }
        ]
    },
    {
        "Id": 78,
        "ParentId": 0,
        "Guid": "06be8568-953a-4cfd-a863-5e33bf98d52f",
        "Level": 1,
        "Label": null,
        "TopicName": "Physics",
        "TotalTests": 0,
        "AssignedTests": 0,
        "SubObjectList": [
            {
                "Id": 88,
                "ParentId": 78,
                "Guid": "4b03066c-99ab-4728-903c-e8ba6bd00db3",
                "Level": 2,
                "Label": null,
                "TopicName": "Mechanics",
                "TotalTests": 0,
                "AssignedTests": 0,
                "SubObjectList": [
                    {
                        "Id": 92,
                        "ParentId": 88,
                        "Guid": "7c10878e-7c9c-4476-91a5-2e971170bc51",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Experiment and Errors",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 118,
                        "ParentId": 88,
                        "Guid": "2b28ee13-655c-49bb-a6f2-72536c75f972",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Heat and Thermodynamics",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 97,
                        "ParentId": 88,
                        "Guid": "7348e06c-7e54-4ad6-8092-b62fa31b8859",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Mathematics in Physics",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 89,
                        "ParentId": 88,
                        "Guid": "a63f2631-f6a6-4751-8702-1e31bf30fe5d",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Center of Mass Momentum and Collision",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 105,
                        "ParentId": 88,
                        "Guid": "f51822bd-8bdb-431b-8f8d-2d61ea5a696e",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Thermodynamics",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 91,
                        "ParentId": 88,
                        "Guid": "64a81b0a-c11e-4ff2-85d2-0d51b2a8778e",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Dual Nature of Matter",
                        "TotalTests": 2,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 106,
                        "ParentId": 88,
                        "Guid": "5b8e86e5-b1ad-4372-b5e4-91afe565c2af",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Units and Dimensions",
                        "TotalTests": 2,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 94,
                        "ParentId": 88,
                        "Guid": "6dc951cf-4b32-41a9-abd4-1da40967e00b",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Gravitation",
                        "TotalTests": 2,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 95,
                        "ParentId": 88,
                        "Guid": "e9c156bd-91eb-4f79-bd9c-602c815b5478",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Kinetic Theory of Gases",
                        "TotalTests": 2,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 101,
                        "ParentId": 88,
                        "Guid": "a53fffb5-0827-4d64-9f89-fd33bbeee689",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Motion In Two Dimensions",
                        "TotalTests": 2,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 104,
                        "ParentId": 88,
                        "Guid": "2f77fd03-450b-408b-ae42-254803276e74",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Thermal Properties of Matter",
                        "TotalTests": 2,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 96,
                        "ParentId": 88,
                        "Guid": "e42f773c-f066-4e00-af49-1310ede21f02",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Laws of Motion",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 98,
                        "ParentId": 88,
                        "Guid": "2f6cb021-1798-41fc-9261-370b1b89c327",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Mechanical Properties of Fluids",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 99,
                        "ParentId": 88,
                        "Guid": "0b62a28b-4d17-491f-b23e-c36e996308b8",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Mechanical Properties of Solids",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 100,
                        "ParentId": 88,
                        "Guid": "5353b25d-1de0-4943-93f7-cd3be20d4ed1",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Motion In One Dimension",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 109,
                        "ParentId": 88,
                        "Guid": "6651da0d-ea2b-4139-b549-0acf177cdc61",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Work Power and Energy",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 103,
                        "ParentId": 88,
                        "Guid": "234a6ed0-6241-42d5-af63-e38817465197",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Rotational Motion",
                        "TotalTests": 4,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 102,
                        "ParentId": 88,
                        "Guid": "17ff5407-dfc8-4705-a326-073fcb8f8396",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Oscillations",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 107,
                        "ParentId": 88,
                        "Guid": "d86039a4-b9ee-4d4c-928a-de6a1d9730c4",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Wave Optics",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 108,
                        "ParentId": 88,
                        "Guid": "1232fc77-1b20-48d8-958d-957916665cbd",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Waves and Sounds",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    }
                ]
            },
            {
                "Id": 79,
                "ParentId": 78,
                "Guid": "6087a7c3-c5fa-4505-89bd-8fe89c251c9c",
                "Level": 2,
                "Label": null,
                "TopicName": "Chapter related to Electrostatistics",
                "TotalTests": 0,
                "AssignedTests": 0,
                "SubObjectList": [
                    {
                        "Id": 85,
                        "ParentId": 79,
                        "Guid": "d4fbff82-1e00-461b-8fd6-73513f07fcf6",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Electrostatistics",
                        "TotalTests": 0,
                        "AssignedTests": 0,
                        "SubObjectList": [
                            {
                                "Id": 139,
                                "ParentId": 85,
                                "Guid": "86a1dfff-43cc-430f-8e11-720772289a2a",
                                "Level": 4,
                                "Label": null,
                                "TopicName": "Electric Charges and Fields",
                                "TotalTests": 1,
                                "AssignedTests": 0,
                                "SubObjectList": []
                            },
                            {
                                "Id": 140,
                                "ParentId": 85,
                                "Guid": "ab5c2120-e845-4e55-a860-1e5e629fa80f",
                                "Level": 4,
                                "Label": null,
                                "TopicName": "Electrostatic Potential and Capacitance",
                                "TotalTests": 1,
                                "AssignedTests": 0,
                                "SubObjectList": []
                            }
                        ]
                    },
                    {
                        "Id": 139,
                        "ParentId": 79,
                        "Guid": "1218e6c4-16fe-4dbf-9a3a-4a6f445bfd8a",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Electric Charges and Fields",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 140,
                        "ParentId": 79,
                        "Guid": "0c7c82b8-2df0-4df8-b99d-30ad27fc2349",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Electrostatic Potential and Capacitance",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 86,
                        "ParentId": 79,
                        "Guid": "5c118fc6-2f5e-4a6a-9a65-f094ba6becd0",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Magnetic Effects of Current",
                        "TotalTests": 0,
                        "AssignedTests": 0,
                        "SubObjectList": [
                            {
                                "Id": 141,
                                "ParentId": 86,
                                "Guid": "1a43b69c-8963-4a25-bc6d-0887f54998b5",
                                "Level": 4,
                                "Label": null,
                                "TopicName": "Magnetism and Matter",
                                "TotalTests": 1,
                                "AssignedTests": 0,
                                "SubObjectList": []
                            },
                            {
                                "Id": 142,
                                "ParentId": 86,
                                "Guid": "9e1e39e3-f453-42ad-ae9d-d1da4d2f264a",
                                "Level": 4,
                                "Label": null,
                                "TopicName": "Moving Charges and Magnetism",
                                "TotalTests": 1,
                                "AssignedTests": 0,
                                "SubObjectList": []
                            }
                        ]
                    },
                    {
                        "Id": 141,
                        "ParentId": 79,
                        "Guid": "1ed4d751-1bb9-4485-8af9-4844fca00df5",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Magnetism and Matter",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 142,
                        "ParentId": 79,
                        "Guid": "d0256381-b88b-4164-987a-73eb87c67354",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Moving Charges and Magnetism",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 81,
                        "ParentId": 79,
                        "Guid": "2947227b-e650-4e8a-a084-751da1af1fd6",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Capacitance",
                        "TotalTests": 1,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 80,
                        "ParentId": 79,
                        "Guid": "d64b0ef2-37fa-4a49-9ebc-275be7d7cd3e",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Alternating Current",
                        "TotalTests": 2,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 84,
                        "ParentId": 79,
                        "Guid": "fd52ae90-ed0d-485a-9386-2f776864e076",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Electromagnetic Waves",
                        "TotalTests": 2,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 83,
                        "ParentId": 79,
                        "Guid": "8ca00439-ca93-4e43-a06e-c671ef08a495",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Electromagnetic Induction and Ac",
                        "TotalTests": 2,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 82,
                        "ParentId": 79,
                        "Guid": "95e33053-0bf0-4ae2-a463-f70839de6034",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Current Electricity",
                        "TotalTests": 5,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    }
                ]
            },
            {
                "Id": 110,
                "ParentId": 78,
                "Guid": "09f8080b-8ea7-49ce-85e7-cb31c315619c",
                "Level": 2,
                "Label": null,
                "TopicName": "Modern Physics",
                "TotalTests": 0,
                "AssignedTests": 0,
                "SubObjectList": [
                    {
                        "Id": 112,
                        "ParentId": 110,
                        "Guid": "521566aa-8f86-4009-9cc5-45eebe7b59af",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Communication System",
                        "TotalTests": 2,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 113,
                        "ParentId": 110,
                        "Guid": "a65d8b9d-bdbd-4518-af79-dd67cc3a0674",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Nuclear Physics",
                        "TotalTests": 2,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 111,
                        "ParentId": 110,
                        "Guid": "b3c41a63-05ee-4200-a1fc-d558fdd40ad7",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Atomic Physics",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    },
                    {
                        "Id": 114,
                        "ParentId": 110,
                        "Guid": "18fbf833-b4ce-4498-80fd-4a8ba460ddb1",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Semiconductors and Electrons",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    }
                ]
            },
            {
                "Id": 115,
                "ParentId": 78,
                "Guid": "4727f5e2-54af-417f-9e10-d144c7de8931",
                "Level": 2,
                "Label": null,
                "TopicName": "Optical Instruments",
                "TotalTests": 0,
                "AssignedTests": 0,
                "SubObjectList": [
                    {
                        "Id": 116,
                        "ParentId": 115,
                        "Guid": "12a91f54-6532-402a-8f56-1255c51237ac",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Ray Optics",
                        "TotalTests": 3,
                        "AssignedTests": 0,
                        "SubObjectList": []
                    }
                ]
            }
        ]
    },
    {
        "Id": 1,
        "ParentId": 0,
        "Guid": "e42decbd-2abe-4307-84af-5ad74402f8c7",
        "Level": 1,
        "Label": null,
        "TopicName": "Chemistry",
        "TotalTests": 0,
        "AssignedTests": 0,
        "SubObjectList": [
            {
                "Id": 2,
                "ParentId": 1,
                "Guid": "8481587d-7d61-4461-96ba-a267a3ce0fbd",
                "Level": 2,
                "Label": null,
                "TopicName": "Inorganic Chemistry",
                "TotalTests": 0,
                "AssignedTests": 0,
                "SubObjectList": [
                    {
                        "Id": 125,
                        "ParentId": 2,
                        "Guid": "9b831f70-4b6f-4584-bbf8-1bf1818bee4e",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Chemistry in Every Day Life",
                        "TotalTests": 1,
                        "AssignedTests": 1,
                        "SubObjectList": []
                    },
                    {
                        "Id": 126,
                        "ParentId": 2,
                        "Guid": "89069a2b-ddd0-4623-bf03-898d498cad69",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Environmental Chemistry",
                        "TotalTests": 1,
                        "AssignedTests": 1,
                        "SubObjectList": []
                    },
                    {
                        "Id": 127,
                        "ParentId": 2,
                        "Guid": "c7ce92d9-b5d0-4861-ac5e-5632021141ab",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Hydrogen",
                        "TotalTests": 1,
                        "AssignedTests": 1,
                        "SubObjectList": []
                    },
                    {
                        "Id": 128,
                        "ParentId": 2,
                        "Guid": "7e6c0d23-ff52-4951-a9d6-300ead0ee613",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "p-Block Elements Part 1 Group 13-14",
                        "TotalTests": 1,
                        "AssignedTests": 1,
                        "SubObjectList": []
                    },
                    {
                        "Id": 129,
                        "ParentId": 2,
                        "Guid": "4601288b-547d-4f4f-abe4-e2fc9b29b859",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "p-Block Elements Part 1 Group 15-18",
                        "TotalTests": 1,
                        "AssignedTests": 1,
                        "SubObjectList": []
                    },
                    {
                        "Id": 130,
                        "ParentId": 2,
                        "Guid": "676b65fe-d391-427d-8706-697e1aeb2974",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "s-Block Elements",
                        "TotalTests": 1,
                        "AssignedTests": 1,
                        "SubObjectList": []
                    },
                    {
                        "Id": 4,
                        "ParentId": 2,
                        "Guid": "e8af9ad1-f60f-4900-84b0-6a1acf73531f",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Chemistry in Every Day Life and Environmental Chemistry",
                        "TotalTests": 2,
                        "AssignedTests": 2,
                        "SubObjectList": []
                    },
                    {
                        "Id": 8,
                        "ParentId": 2,
                        "Guid": "7b8f0274-75f7-4d11-b819-4d098bb59a7e",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "p-Block Elements",
                        "TotalTests": 2,
                        "AssignedTests": 2,
                        "SubObjectList": []
                    },
                    {
                        "Id": 9,
                        "ParentId": 2,
                        "Guid": "1cf64cef-8923-45c0-a9f6-5d1274980c41",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Periodic Properties",
                        "TotalTests": 2,
                        "AssignedTests": 2,
                        "SubObjectList": []
                    },
                    {
                        "Id": 10,
                        "ParentId": 2,
                        "Guid": "deb46ff2-7a17-468d-b9ab-77b0e2ab80f6",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "s-Block Elements and Hydrogen",
                        "TotalTests": 2,
                        "AssignedTests": 2,
                        "SubObjectList": []
                    },
                    {
                        "Id": 3,
                        "ParentId": 2,
                        "Guid": "607af0f1-fbc6-4bfa-8a19-2749168615dd",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Chemical Bonding",
                        "TotalTests": 2,
                        "AssignedTests": 2,
                        "SubObjectList": []
                    },
                    {
                        "Id": 6,
                        "ParentId": 2,
                        "Guid": "041af794-8151-4a92-a833-bdde1af5822a",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "d and f-Block Elements",
                        "TotalTests": 2,
                        "AssignedTests": 2,
                        "SubObjectList": []
                    },
                    {
                        "Id": 7,
                        "ParentId": 2,
                        "Guid": "d6792c9a-38e6-46b4-a184-2f5772f07c2e",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Ores and Metallurgy",
                        "TotalTests": 2,
                        "AssignedTests": 2,
                        "SubObjectList": []
                    },
                    {
                        "Id": 5,
                        "ParentId": 2,
                        "Guid": "9a016750-6841-41eb-8375-96250f74a00b",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Coordination Compounds",
                        "TotalTests": 3,
                        "AssignedTests": 3,
                        "SubObjectList": []
                    }
                ]
            },
            {
                "Id": 11,
                "ParentId": 1,
                "Guid": "1c628443-54d1-4b21-a4e6-f57fa77cc776",
                "Level": 2,
                "Label": null,
                "TopicName": "Organic Chemistry",
                "TotalTests": 0,
                "AssignedTests": 0,
                "SubObjectList": [
                    {
                        "Id": 131,
                        "ParentId": 11,
                        "Guid": "c77154ad-cc3e-474c-b683-10e8e00ac074",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Biomolecules",
                        "TotalTests": 1,
                        "AssignedTests": 1,
                        "SubObjectList": []
                    },
                    {
                        "Id": 132,
                        "ParentId": 11,
                        "Guid": "6ce98f05-c974-47b8-afd8-cb37725e606a",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Polymers",
                        "TotalTests": 1,
                        "AssignedTests": 1,
                        "SubObjectList": []
                    },
                    {
                        "Id": 12,
                        "ParentId": 11,
                        "Guid": "9e9286be-61ff-4819-8e45-d58030e92e9c",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Alcohol Ether and Phenols",
                        "TotalTests": 2,
                        "AssignedTests": 2,
                        "SubObjectList": []
                    },
                    {
                        "Id": 13,
                        "ParentId": 11,
                        "Guid": "5900e676-a3aa-493c-a94b-1eff66c2e34e",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Aldehyde and Ketones",
                        "TotalTests": 2,
                        "AssignedTests": 2,
                        "SubObjectList": []
                    },
                    {
                        "Id": 14,
                        "ParentId": 11,
                        "Guid": "b66781fb-b410-4608-b4d5-297bacf31d93",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Alkyl Halides and Aryl Halides",
                        "TotalTests": 2,
                        "AssignedTests": 2,
                        "SubObjectList": []
                    },
                    {
                        "Id": 20,
                        "ParentId": 11,
                        "Guid": "71576e0b-d9d2-462c-a05f-c347d9af27c9",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Polymer and Biomolecules and Carbohydrates",
                        "TotalTests": 2,
                        "AssignedTests": 2,
                        "SubObjectList": []
                    },
                    {
                        "Id": 19,
                        "ParentId": 11,
                        "Guid": "fd772b43-1803-4cfd-87cf-8e173d9f909d",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Hydrocarbons",
                        "TotalTests": 2,
                        "AssignedTests": 2,
                        "SubObjectList": []
                    },
                    {
                        "Id": 15,
                        "ParentId": 11,
                        "Guid": "60856caa-1f8f-4332-ac66-1f713f968e24",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Amines",
                        "TotalTests": 3,
                        "AssignedTests": 3,
                        "SubObjectList": []
                    },
                    {
                        "Id": 18,
                        "ParentId": 11,
                        "Guid": "9fb0448a-cbfb-4cfa-9eec-da4e1da266b9",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "General Organic Chemistry",
                        "TotalTests": 4,
                        "AssignedTests": 4,
                        "SubObjectList": []
                    }
                ]
            },
            {
                "Id": 22,
                "ParentId": 1,
                "Guid": "eb8d7ed9-7bd3-4bda-82c0-6003317408bc",
                "Level": 2,
                "Label": null,
                "TopicName": "Physical Chemistry",
                "TotalTests": 0,
                "AssignedTests": 0,
                "SubObjectList": [
                    {
                        "Id": 133,
                        "ParentId": 22,
                        "Guid": "f1994446-342d-4eb2-a624-5a521f63ab85",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Chemical and Ionic Equilibrium",
                        "TotalTests": 1,
                        "AssignedTests": 1,
                        "SubObjectList": []
                    },
                    {
                        "Id": 33,
                        "ParentId": 22,
                        "Guid": "adf2cc84-1ebb-40d5-aae4-162633da1967",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "States of Matter",
                        "TotalTests": 1,
                        "AssignedTests": 1,
                        "SubObjectList": []
                    },
                    {
                        "Id": 27,
                        "ParentId": 22,
                        "Guid": "a5191ed8-3b6c-4460-8db9-e4690bf49cf4",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Concept Balancing of Redox Reaction and Stoichiometry",
                        "TotalTests": 2,
                        "AssignedTests": 2,
                        "SubObjectList": []
                    },
                    {
                        "Id": 31,
                        "ParentId": 22,
                        "Guid": "b3724ce3-0083-4e27-9d13-09dc6897e39a",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Solid State",
                        "TotalTests": 2,
                        "AssignedTests": 2,
                        "SubObjectList": []
                    },
                    {
                        "Id": 34,
                        "ParentId": 22,
                        "Guid": "d36d7d24-e285-48cf-85c3-7a71c83cafe4",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Surface Chemistry and Colloids",
                        "TotalTests": 2,
                        "AssignedTests": 2,
                        "SubObjectList": []
                    },
                    {
                        "Id": 30,
                        "ParentId": 22,
                        "Guid": "ddab64ae-22f1-40ec-af05-7a9d672aaec3",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Liquid Solution and Colligative Properties",
                        "TotalTests": 4,
                        "AssignedTests": 4,
                        "SubObjectList": []
                    },
                    {
                        "Id": 35,
                        "ParentId": 22,
                        "Guid": "a7d44bb3-b962-41c9-94e0-553efaa4e338",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Thermodynamics and Thermochemistry",
                        "TotalTests": 4,
                        "AssignedTests": 4,
                        "SubObjectList": []
                    },
                    {
                        "Id": 23,
                        "ParentId": 22,
                        "Guid": "dae85865-3541-45d5-a2a6-fcfc8d443b34",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Atomic Structure",
                        "TotalTests": 3,
                        "AssignedTests": 3,
                        "SubObjectList": []
                    },
                    {
                        "Id": 25,
                        "ParentId": 22,
                        "Guid": "6787f43f-06eb-4f6f-b03b-b641045f6a2d",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Chemical Kinetics and Nuclear Chemistry",
                        "TotalTests": 2,
                        "AssignedTests": 2,
                        "SubObjectList": []
                    },
                    {
                        "Id": 28,
                        "ParentId": 22,
                        "Guid": "ba110ada-7846-4a32-9856-2516bd955924",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Electrochemistry",
                        "TotalTests": 2,
                        "AssignedTests": 2,
                        "SubObjectList": []
                    },
                    {
                        "Id": 32,
                        "ParentId": 22,
                        "Guid": "b63db7a4-dc43-4401-a613-5e9f53d91eae",
                        "Level": 3,
                        "Label": null,
                        "TopicName": "Some Basic Concept of Chemistry",
                        "TotalTests": 2,
                        "AssignedTests": 2,
                        "SubObjectList": []
                    }
                ]
            }
        ]
    }
]

const OwnTestCreation = () => {
    const [expandedRootId, setExpandedRootId] = useState(null);
    const [expandedItems, setExpandedItems] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [showTestDetails, setShowTestDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [alertMsg, setAlertMsg] = React.useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const { UserId, setPageKey, activeUserSubscriptionId, setActiveUserSubscriptionId, showSubscriptionData, setShowSubscriptionData, setStatus, setIsDrawerNavigation, setAssessmet, userDetail } = useContext(LoginContext);

    useEffect(() => {
        async function fetchData() {
            // setData(data1)
            setLoading(true);
            let response = await axios.get(
                `${configUrl.AssessmentServer}/api/SwotAnalytics/getUserTopicsForTests/${UserId}`);
            console.log("data hierarchy ", response);
            setData(response?.data);
            setLoading(false);
        }
        fetchData()
    }, [])

    async function fetchSubscriptionData() {
        const resp = await getUserTopicsForTestsService.getTestSubscriptionDetails(UserId);
        console.log("susbcition data is ", resp);
        const date = new Date(resp?.endDate);
        const localDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000));
        const now = new Date();
        const isActive = isAfter(localDate, now);
        if (resp) {
            if (resp?.endDate === null && (resp?.subscriptionTypeId === 1 || resp?.subscriptionTypeId === 3)) {
                setActiveUserSubscriptionId(resp?.userSubscriptionId);
            } else {
                if (isActive && (resp?.subscriptionTypeId === 1 || resp?.subscriptionTypeId === 3)) {
                    console.log("not expired")
                    setActiveUserSubscriptionId(resp?.userSubscriptionId);
                } else {
                    console.log("subscritionnot expired")
                    setActiveUserSubscriptionId(0);
                }
            }
            setShowSubscriptionData(resp);
        }
    }
    const toggleRootExpand = (id) => {
        setExpandedRootId((prev) => (prev === id ? null : id));
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };
    const toggleExpand = (id) => {
        setExpandedItems((prev) =>
            prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
        );
    };

    const toggleSelection = (item) => {
        const exists = selectedItems.find((i) => i.Id === item.Id);
        if (exists) {
            setSelectedItems((prev) => prev.filter((i) => i.Id !== item.Id));
        } else {
            setSelectedItems((prev) => [...prev, item]);
        }
    };
    const renderSubLevel = (nodes, parentLevel = 1) => {
        if (!nodes || nodes.length === 0) return null;

        let level3Items = [];

        return (
            <>
                {/* LEVEL 2 BUTTONS */}
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', marginTop: 2 }}>
                    {nodes.map((node) => {
                        const isSelected = selectedItems.some((i) => i.Id === node.Id);
                        const isExpanded = expandedItems.includes(node.Id);
                        const hasChildren = node.SubObjectList?.length > 0;

                        if (hasChildren && isExpanded) {
                            level3Items = [...level3Items, ...node.SubObjectList];
                        }

                        return (
                            <Box key={node.Id} sx={{ mb: 2 }}>
                                {hasChildren ? (
                                    <Button
                                        onClick={() => toggleExpand(node.Id)}
                                        sx={{
                                            backgroundColor: isExpanded
                                                ? 'rgba(230, 60, 56, 0.1)' // Active color
                                                : 'rgba(35, 196, 216, 0.1)', // Default color
                                            borderRadius: '0',
                                            padding: '10px 19px 10px 29px',
                                            fontFamily: 'Poppins',
                                            fontSize: '12px',
                                            textTransform: 'none',
                                            color: '#594e4e',
                                        }}
                                    >
                                        {node.TopicName}
                                    </Button>
                                ) : (
                                    <Button
                                        onClick={() => toggleSelection(node)}
                                        sx={{
                                            backgroundColor: isSelected
                                                ? '#002147' // Selected color
                                                : 'rgba(35, 196, 216, 0.1)',
                                            borderRadius: '0',
                                            padding: '10px 19px 10px 29px',
                                            fontFamily: 'Poppins',
                                            fontSize: '12px',
                                            textTransform: 'none',
                                            color: isSelected ? '#fff' : '#594e4e',
                                        }}
                                    >
                                        {node.TopicName}
                                    </Button>
                                )}
                            </Box>
                        );
                    })}
                </Box>

                {/* LEVEL 3 AND LEVEL 4 BUTTONS */}
                {level3Items.length > 0 && (
                    <Box sx={{ mt: 2 }}>
                        <Divider sx={{ mb: 1, borderBottomWidth: '2px', borderColor: '#002147' }} />
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            {level3Items.map((sub) => {
                                const isSelected = selectedItems.some((i) => i.Id === sub.Id);
                                const hasLevel4 = sub.SubObjectList && sub.SubObjectList.length > 0;
                                const isExpanded = expandedItems.includes(sub.Id);

                                return (
                                    <Box key={sub.Id}>
                                        {/* LEVEL 3 BUTTONS */}
                                        <Button
                                            disabled={hasLevel4 ? false : sub.TotalTests === 0 || sub.TotalTests === sub.AssignedTests}
                                            onClick={() =>
                                                // hasLevel4 ? toggleExpand(sub.Id) : toggleSelection(sub)
                                                toggleSelection(sub)
                                            }
                                            sx={{
                                                backgroundColor: isSelected
                                                    ? '#002147' // Selected
                                                    : isExpanded
                                                        ? 'rgba(230, 60, 56, 0.1)' // Active
                                                        : 'rgba(35, 196, 216, 0.1)', // Default
                                                borderRadius: '0',
                                                padding: '10px 19px 10px 29px',
                                                fontFamily: 'Poppins',
                                                fontSize: '12px',
                                                textTransform: 'none',
                                                color: isSelected ? '#fff' : '#594e4e',
                                                '&:hover': {
                                                    backgroundColor: isSelected
                                                        ? '#002147'
                                                        : 'rgba(35, 196, 216, 0.2)',
                                                },
                                            }}
                                        >
                                            {sub.TopicName}
                                        </Button>

                                        {/* LEVEL 4 BUTTONS */}
                                        {hasLevel4 && isExpanded && (
                                            <Box sx={{ mt: 2 }}>
                                                <Divider sx={{ mb: 1, borderBottomWidth: '2px', borderColor: '#002147' }} />
                                                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                                    {sub.SubObjectList.map((lvl4) => {
                                                        const isLvl4Selected = selectedItems.some(
                                                            (i) => i.Id === lvl4.Id
                                                        );
                                                        return (
                                                            <Button
                                                                key={lvl4.Id}
                                                                disabled={lvl4.TotalTests === 0 || lvl4.TotalTests === lvl4.AssignedTests}
                                                                onClick={() => toggleSelection(lvl4)}
                                                                sx={{
                                                                    backgroundColor: isLvl4Selected
                                                                        ? '#002147' // Selected
                                                                        : 'rgba(35, 196, 216, 0.1)', // Default
                                                                    borderRadius: '0',
                                                                    padding: '10px 19px 10px 29px',
                                                                    fontFamily: 'Poppins',
                                                                    fontSize: '11px',
                                                                    textTransform: 'none',
                                                                    color: isLvl4Selected ? '#fff' : '#594e4e',
                                                                    '&:hover': {
                                                                        backgroundColor: isLvl4Selected
                                                                            ? '#002147'
                                                                            : 'rgba(35, 196, 216, 0.2)',
                                                                    },
                                                                }}
                                                            >
                                                                {lvl4.TopicName}
                                                            </Button>
                                                        );
                                                    })}
                                                </Box>
                                            </Box>
                                        )}
                                    </Box>
                                );
                            })}
                        </Box>
                    </Box>
                )}
            </>
        );
    };

    const subscriptionStatusData = {
        attemptedTests: 12,
        subExpDate: '2025-05-01',
        remaingDays: 21
    };
    const createTests = async () => {
        let maxTestsCount = showSubscriptionData?.remainingTests ?? 0;
        if (maxTestsCount === 0) {
            setAlertMsg(`Your current plan doesn’t allow more tests.Please purchase a new subscription to continue.`)
            setOpen(true);
            return;
        }
        if (selectedItems?.length > maxTestsCount) {
            setAlertMsg(`You can only select ${maxTestsCount} tests.`)
            setOpen(true);
            return;
        }
        setLoading(true);
        let subscriptionId = activeUserSubscriptionId;
        const selectedTopicIds = selectedItems.map(item => item.Id);
        const resp = await assignTopicTestsToUser.assignTopicTestsToUser(UserId, subscriptionId, selectedTopicIds);
        console.log(resp, 'created Test');
        if (resp?.status === 200) {
            fetchSubscriptionData();
            setDialogOpen(false);
            setStatus("PENDING");
            setIsDrawerNavigation(true);
            setAssessmet(true);
            setPageKey(5);

        }
        setLoading(false);
    }
    const hideTestDetails = () => {
        fetchSubscriptionData();
        setShowTestDetails(null);
    }
    const handleRenew = async () => {
        const subscriptions = await getAllSubscriptionsService();

        setShowTestDetails(
            <CustomModal
                modal={true}
                setModal={hideTestDetails}
                content={<TestDetailsPage subscription={subscriptions?.length > 0 ? subscriptions[0] : null} isLoggedIn={true} hideTestDetails={hideTestDetails} />}
                showOk={false}
                showCancel={false}
                onCancelClick={hideTestDetails}
                title={
                    isMobile ?
                        'Unlock 10 Tests @ ₹ 390!' :
                        'Unlock 10 Topicwise Tests Just @ ₹ 390!'
                }
                maxWidth="md"
                hideTitle={true}
                fullWidth={false}
                isHeaderBackground={true}
            />
        )
    }

    return (
        <Box sx={{ padding: 4 }}>
            <Snackbar anchorOrigin={{ vertical: "top", horizontal: "center" }} open={open} onClose={handleClose} autoHideDuration={5000}>
                <MuiAlert severity="error"
                    onClose={handleClose}
                    sx={{ fontSize: "15px", width: "100%" }}
                >
                    {alertMsg}
                </MuiAlert>
            </Snackbar>
            <Grid container>

                <Grid container justifyContent="center">
                    {activeUserSubscriptionId === 0 ? (
                        <Grid item xs={12} sm={10} md={8}>
                            <Alert
                                type="warning"
                                showIcon={false}
                                description={
                                    <>
                                        <div>
                                            {(showSubscriptionData && (showSubscriptionData?.subscriptionTypeId === 1 || showSubscriptionData?.subscriptionTypeId === 3)) ? "Your free test subscription has ended. To keep accessing premium features like detailed analytics, results, and solutions, purchase a new test series now." : t("ChooseYourTestisavailableforsubscribersonly")}
                                        </div>
                                    </>
                                }
                                className={styles.noSubscriptionCard}
                            />
                        </Grid>
                    ) : (showSubscriptionData?.remainingTests === 0 && userDetail?.userTypeId === 12) ? (
                        <Grid item xs={12} sm={10} md={8}>
                            <Alert
                                type="info"
                                showIcon={false}
                                description={
                                    <>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 4 }}>
                                            {/* <ExclamationCircleOutlined style={{ fontSize: '20px', color: '#faad14', marginRight: 8 }} /> */}
                                            <span style={{ fontSize: '16px', fontWeight: '600' }}>Your free test subscription has ended.</span>
                                        </div>
                                        <div>
                                            {"To keep accessing premium features like detailed analytics, results, and solutions, purchase a new test series now."}
                                        </div>
                                    </>
                                }
                                className={styles.noSubscriptionCard}
                            />
                        </Grid>
                    )
                        : null}
                </Grid>
                <Grid item sm={12} md={6}>
                    <h4 className={styles.notificationHead} style={{ color: '#012248' }}>{t("pickYourTest")}</h4>
                </Grid>
                <Grid item sm={12} md={6} style={{ textAlign: 'right' }}>
                    <button
                        className={styles.CreateTestButton}
                        onClick={() => handleRenew()}
                    // disabled={selectedItems.length === 0}
                    >
                        {t("subscribeBtn")}
                    </button>
                    <button
                        className={selectedItems.length === 0 || activeUserSubscriptionId === 0 ? styles.disabledButton : styles.CreateTestButton}
                        onClick={() => setDialogOpen(true)}
                        disabled={selectedItems.length === 0 || activeUserSubscriptionId === 0}
                    >
                        {t('topicSelectedBtn')}{`(${selectedItems.length})`}
                    </button>

                </Grid>
            </Grid>


            {/* Level 1 */}
            {/* <Typography variant="h6">Level 1</Typography> */}
            {loading ?
                <Box sx={{ justifyContent: 'center' }}>
                    <CircularProgress /><br />
                    {"Loading..."}
                </Box>

                :
                <>
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                        {data?.map((node) => {
                            const isExpanded = expandedRootId === node.Id;
                            return (
                                <Button
                                    key={node.Id}
                                    variant={isExpanded ? 'contained' : 'outlined'}
                                    color={isExpanded ? 'primary' : 'inherit'}
                                    onClick={() => toggleRootExpand(node.Id)}
                                    sx={{
                                        borderRadius: '0',
                                        padding: '10px 19px 10px 29px',
                                        fontFamily: 'Poppins',
                                        fontSize: '12px',
                                        textTransform: 'none',
                                        color: '#594e4e',
                                        backgroundColor: isExpanded ? 'rgba(230, 60, 56, 0.1)' : '',
                                        '&:hover': {
                                            backgroundColor: isExpanded
                                                ? 'rgba(230, 60, 56, 0.1)' // Same as selected background
                                                : 'rgba(230, 60, 56, 0.2)', // Slightly darker hover for unselected
                                        },
                                    }}
                                >
                                    {node.TopicName}
                                </Button>
                            );
                        })}
                    </Box>
                    <Divider sx={{ my: 2, borderBottomWidth: '2px', borderColor: '#002147' }} />
                </>
            }
            {/* Level 2 (if root expanded) */}
            {expandedRootId && (
                <>
                    {/* <Typography variant="h6">Level 2</Typography> */}
                    {renderSubLevel(
                        data.find((n) => n.Id === expandedRootId)?.SubObjectList || [],
                        1
                    )}
                </>
            )}

            {/* Dialog for selected items */}
            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} fullWidth>
                <DialogTitle> <h5 className={styles.selectedItems} style={{ margin: '0' }}>{t("CreateTestModalTitle")}</h5></DialogTitle>
                <DialogContent dividers>
                    {selectedItems.length === 0 ? (
                        <Typography>No selections made.</Typography>
                    ) : (
                        selectedItems.map((item, index) => (
                            <Box key={item.Id} sx={{ mb: 1 }}>
                                <h5 className={styles.selectedItems} style={{ color: '#012248' }}>{`${index + 1}. ${item.TopicName}`}

                                    <IconButton
                                        onClick={() => {
                                            setSelectedItems(prev => prev.filter(i => i.Id !== item.Id));
                                        }}
                                        size="small"
                                        color="error"
                                    >
                                        🗑️
                                        {/* <DeleteIcon /> */}
                                    </IconButton>
                                </h5>
                                {/* <Typography variant="body2">
                                    Assigned: {item.AssignedQuestionCount}, Attempted: {item.AttemptedQuestionCount}, Correct:{' '}
                                    {item.CorrectQuestionCount}, Incorrect: {item.IncorrectQuestionCount}
                                </Typography> */}
                            </Box>
                        ))
                    )}
                </DialogContent>
                <DialogActions>
                    <button
                        className={styles.CloseButton}
                        onClick={() => setDialogOpen(false)}
                    // disabled={selectedItems.length === 0}
                    >
                        {t("cancelBtn")}
                    </button>
                    <button
                        className={selectedItems.length === 0 || loading === true ? styles.disabledButton : styles.CreateTestButton}
                        onClick={() => createTests()}
                        disabled={selectedItems.length === 0 || loading === true}
                    >
                        {loading ? t("creating") : t("createTest")}
                    </button>
                </DialogActions>
            </Dialog>
            {
                showTestDetails
            }
        </Box>
    );
};



export default OwnTestCreation;
